var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-rank.44379ae6.png","uri@2x": __webpack_public_path__ + "icon-rank.8cc5b895.png","uri@3x": __webpack_public_path__ + "icon-rank.75baf7f6.png",
    width: 38,
    height: 38
});